import MobileHeaderNavigation from './MobileHeaderNavigation.component';

export default MobileHeaderNavigation;
